<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"> </app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações do contas a pagar</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configure as configurações do contas a pagar.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="row">
        <div class="col-12">
          <app-loading-box height="40" width="100%"></app-loading-box>
          <app-loading-box height="20" width="60%" marginTop="12"></app-loading-box>
          <app-loading-box height="56" width="100%" marginTop="24"></app-loading-box>
        </div>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <mat-slide-toggle formControlName="isAvisarEmail" color="primary">
              Avisar por e-mail sobre contas a pagar no dia do vencimento
            </mat-slide-toggle>
            <div class="hint-text mt-2 mb-4">
              Envia um alerta diário às 06:30h (Horário de Brasília) se houver contas vencendo no dia.
            </div>
          </div>

          @if (form.get('isAvisarEmail')?.value) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>E-mails para notificação</mat-label>
                <input
                  matInput
                  #emailInput
                  placeholder="contato@empresa.com.br; financeiro@empresa.com.br"
                  formControlName="email" />
                @if (form.get('email')?.hasError('required')) {
                  <mat-error> O e-mail é obrigatório quando a opção está ativa. </mat-error>
                }
                @if (
                  form.get('email')?.hasError('invalidMultipleEmails') &&
                  !form.get('email')?.hasError('required')
                ) {
                  <mat-error>
                    Formato de e-mail inválido. Separe múltiplos e-mails por ponto e vírgula.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>
